import React, { useEffect, useState } from "react";

import stylesList from "./WorkSpaceItemList.module.css";

import { BatchChangeStatusModel, BatchDownloadModel, IBatchActionContent, IPath } from "../../model/ItemModel";
import { NewFolderConfig } from "./PanelItens/CreateFolderComp";

import { Box, IconButton, Avatar, Container, Divider, Tooltip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import {useParams } from "react-router-dom";
import documentIcon from '../../assets/icons/documento.svg';
import downloadIcon from '../../assets/icons/download.svg';
import pasteIcon from '../../assets/icons/folder_alter.svg';
import ChooseColumns from "../../components/ChooseColumns/ChooseColumns";
import { BatchDownloadPost, SetBatchDraft, SetBatchRelease } from "../../services/Item/ItemServicesCRUD";
import { DownloadWithoutLogin, GetOneItem } from "../../services/Item/ItemServicesGet";
import { PreValidationBatchAction } from "../../services/ValidationRuleService";
import { filesSelected } from "./WorkSpaceItemListFile";
import { Add, Delete } from "@mui/icons-material";
import FolderIcon from '@mui/icons-material/Folder';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RefreshIcon from '@mui/icons-material/Refresh';
import MoveInBatch from "./MoveInBatch/MoveInBatch";
import { useProfile } from "../../context/ProfileProvider/useProfile";

import EditIcon from '@mui/icons-material/Edit';
import KeydriveMenuAction, { IMenuItemAction } from "../../components/KeydriveComponents/KeydriveMenu/KeydriveMenuAction";
import { KeydriveMenuActionStyle } from "../../components/KeydriveComponents/KeydriveMenu/KeydriveMenuActionStyle";
import useExtractPlan from "../../hooks/useExtractPlan";
import { BatchDelete } from "../../services/WorkSpaceServices";
import { KeyDriveDialog } from "../../components/KeydriveComponents/Dialog/KeyDriveDialog";
import { IBatchDeleteReturn } from "../../model/OrganizationModel";
import DeleteInBatchModal from "./DeleteInBatch/DeleteInBatchModal";
import SelectedList from "./MoveInBatch/components/SelectedList";
import KeydriveAlert from "../../components/KeydriveComponents/Alert/KeyDriveAlert";

interface WorkSpaceItemListFileHeaderProps {
    nameOrg: string;
    idWorkspace: string;
    idMongoNewFolder?: string;
    clickUpload: () => void;
    clickUploadFolder: () => void;
    refresh: () => void;
    setFolderConfig: (newFolder: NewFolderConfig) => void;
    typePermission?: number;
    isAdmin: boolean;
    path: IPath[];
    nameFolder: string;
    onClickLinkMap: (idFolder: string | undefined, nameFolder: string | undefined) => void;
    selectedCheckboxes: filesSelected[]
    setPopupError: (set: boolean, message: string) => void;
    setPopupOk: (set: boolean, message: string) => void;
    quantityFileSelected: () => number
    quantityAbleToReleaseSelected: () => number
    quantityAbleToDraftSelected: () => number
    quantityAbleToValidationRuleSelected: () => number
    setSelectedCheckbox: (set: filesSelected[]) => void;
    setCurrentBatchStatus: (set: "DRAFT" | "RELEASE") => void;
    batchRefresh: () => void;
    setBatchWaiter: (se: boolean) => void;
    setIsChecked: React.Dispatch<React.SetStateAction<boolean>>;
    setOpenBatchActionModal: (set: boolean) => void;
    setBatchActionContent: (set: IBatchActionContent) => void;
}

const WorkSpaceItemListFileHeader: React.ForwardRefExoticComponent<WorkSpaceItemListFileHeaderProps> =
    React.forwardRef(({
        nameOrg,
        idWorkspace,
        idMongoNewFolder,
        clickUpload,
        clickUploadFolder,
        refresh,
        setFolderConfig,
        typePermission,
        isAdmin,
        path,
        nameFolder,
        onClickLinkMap,
        selectedCheckboxes,
        setPopupError,
        setPopupOk,
        quantityFileSelected,
        quantityAbleToReleaseSelected,
        quantityAbleToDraftSelected,
        quantityAbleToValidationRuleSelected,
        setSelectedCheckbox,
        setCurrentBatchStatus,
        batchRefresh,
        setBatchWaiter,
        setIsChecked,
        setOpenBatchActionModal,
        setBatchActionContent
    }, ref) => {
        const { t } = useTranslation();
        const [isActionBatch, setIsActionBatch] = useState<boolean>(false);
        const [isAbleToRelease, setIsAbleToRelease] = useState<boolean>(false);
        const [isAbleToDraft, setIsAbleToDraft] = useState<boolean>(false);
        const [isAbleToValidationRule, setIsAbleToValidationRule] = useState<boolean>(false);
        const [menuItems, setMenuItems] = useState<IMenuItemAction[]>([]);
        const [menuItemsBach, setMenuItemsBach] = useState<IMenuItemAction[]>([]);
        const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
        const [needHiddenMenu, setNeedHiddenMenu] = useState<boolean>(false);
        const [isFolderOwner, setIsFolderOwner] = useState<boolean>(false);
        const { id } = useProfile();
        const { keydrivePlan } = useExtractPlan();
        const { idFolder } = useParams();
        const [openDeleteBatchModal, setOpenDeleteBatchModal] = useState<boolean>(false);
        const [batchDeleteResult, setBatchDeleteResult] = useState<IBatchDeleteReturn>();
        const [deleteBatchConfirmModal, setDeleteBatchConfirmModal] = useState<boolean>(false);
        
        const batchDeleteExecute = () => {

            BatchDelete(selectedCheckboxes.map(item => item.id!), nameOrg!, idFolder!, idWorkspace!)
            .then(data => {
                setBatchDeleteResult(data);
                setOpenDeleteBatchModal(true);
            })
            .catch(err => {
                console.log(err.response);
                if(err.response?.status === 400){
                    setPopupError(true, err.response.data);
                    return;
                }
                setPopupError(true, t("DeleteInBatchDialog.ErrorWhenDeletingFiles"));
            })
        }

        const preValidationExecute = () => {
            PreValidationBatchAction(
                selectedCheckboxes.filter(x => x.isFolder == false).flatMap(sc => sc.id!)
            )
                .then(data => {
                    setOpenBatchActionModal(true)
                    setBatchActionContent(data);
                })
                .catch(error => {
                    setOpenBatchActionModal(true)
                })
        }

        const refreshClick = (event: React.MouseEvent<HTMLElement>) => {
            if (refresh)
                refresh();
        };

        const upload = () => {
            if (clickUpload) clickUpload();

            return true;
        };

        const uploadFolder = () => {
            if (clickUploadFolder) clickUploadFolder();

            return true;
        };

        const nefolder = () => {
            const newFolder: NewFolderConfig = {
                idWork: idWorkspace,

                idFolder: idMongoNewFolder,
            };

            setFolderConfig(newFolder);

            return true;
        };

        const moveInBatchClick = () => {
            setIsModalOpen(true)
        }


        const batchDownloadClick = () => {
            const batchDownload: BatchDownloadModel = {
                IdItens: selectedCheckboxes.map(item => item.id),
            };
            BatchDownloadPost(batchDownload)
                .then(res => {
                    if (res.id != undefined) {
                        window.open(DownloadWithoutLogin(res.id), "_blank")?.focus();
                    }
                })
                .catch(err => {
                    setPopupError(true, t("DownloadFileError.message"));
                })
        }

        const batchReleaseClick = () => {
            const batchRelease: BatchChangeStatusModel = {
                idChangeStatus: selectedCheckboxes
                    .filter(item => item.isRelease === false && item.validationRule === undefined)
                    .map(item => item.id),
            }
            var filesReleased: filesSelected[] = selectedCheckboxes.map(file => {
                return {
                    extension: file.extension,
                    id: file.id,
                    img: file.img,
                    isFolder: file.isFolder,
                    name: file.name,
                    isRelease: true,
                    validationRule: undefined
                }
            });
            SetBatchRelease(batchRelease)
                .then(res => {
                    setSelectedCheckbox(filesReleased);
                    batchRefresh();
                    setPopupOk(true, t("FilesWentToRelease.message"))
                    setCurrentBatchStatus("RELEASE");
                    setIsChecked(false);
                })
                .catch(err => {
                    setPopupError(true, t("ErrorWhenUpdatingToRelease.message"));
                })
                .finally(() => {
                    setBatchWaiter(false);
                })
        }

        const batchDraftClick = () => {
            const batchDraft: BatchChangeStatusModel = {
                idChangeStatus: selectedCheckboxes
                    .filter(item => item.isRelease === true && item.validationRule === undefined && !item.isFolder)
                    .map(item => item.id),
            }
            var filesDrafted: filesSelected[] = selectedCheckboxes.map(file => {
                return {
                    extension: file.extension,
                    id: file.id,
                    img: file.img,
                    isFolder: file.isFolder,
                    name: file.name,
                    isRelease: false,
                    validationRule: undefined
                }
            })
            SetBatchDraft(batchDraft)
                .then(res => {
                    setSelectedCheckbox(filesDrafted);
                    batchRefresh();
                    setCurrentBatchStatus("DRAFT");
                    setPopupOk(true, t("FilesWentToDraft.message"));
                    setIsChecked(false);
                })
                .catch(err => {
                    setPopupError(true, t("ErrorWhenUpdatingToDraft.message"));
                })
        }

        useEffect(() => {
            if (needHiddenMenu) {
                setNeedHiddenMenu(false);
            }
        }, [needHiddenMenu]);

        useEffect(() => {
            if (selectedCheckboxes.length > 1) {
                if (quantityFileSelected() >= 2) {
                    setIsActionBatch(true)

                    if (quantityAbleToReleaseSelected() >= 2) {
                        setIsAbleToRelease(true)
                    } else {
                        setIsAbleToRelease(false)
                    }

                    if (quantityAbleToDraftSelected() >= 2) {
                        setIsAbleToDraft(true)
                    } else {
                        setIsAbleToDraft(false)
                    }

                    if (quantityAbleToValidationRuleSelected() >= 2) {
                        setIsAbleToValidationRule(true)
                    } else {
                        setIsAbleToValidationRule(false)
                    }
                } else {
                    setIsActionBatch(false);
                }
            } else {
                setIsActionBatch(false);
                setIsAbleToRelease(false);
                setIsAbleToDraft(false);
                setIsAbleToValidationRule(false);
            }
        }, [selectedCheckboxes, isActionBatch])

        useEffect(() => {
            let items: IMenuItemAction[] = [
                {
                    key: 'draft',
                    text: t('DocumentActionsMenu.draft'),
                    onClick: () => { batchDraftClick() },
                    disabled: !isAbleToDraft,
                    icon: <InsertDriveFileIcon />
                },
                {
                    key: 'download',
                    text: t('DocumentActionsMenu.download'),
                    onClick: () => { batchDownloadClick() },
                    src: downloadIcon
                },
                {
                    key: 'release',
                    text: t('DocumentActionsMenu.release'),
                    onClick: () => { batchReleaseClick() },
                    disabled: !isAbleToRelease,
                    icon: <CheckCircleIcon />
                },
                {
                    key: 'moveTo',
                    text: t('DocumentActionsMenu.moveTo'),
                    onClick: () => { moveInBatchClick() },
                    icon: <FolderIcon />
                },
                {
                    key: 'batchForward',
                    text: t('DocumentActionsMenu.preValidationOfAction'),
                    onClick: () => { preValidationExecute() },
                    disabled: !isAbleToValidationRule,
                    icon: <EditIcon />
                },
                {
                    key: 'batchDelete',
                    text: t('DocumentActionsMenu.BatchDelete'),
                    onClick: () => { setDeleteBatchConfirmModal(true) },
                    disabled: false,
                    icon: <Delete />
                },
            ];

            setMenuItemsBach(items);
        }, [isAbleToRelease, isAbleToDraft, isAbleToValidationRule, selectedCheckboxes]);

        useEffect(() => {
            if (idMongoNewFolder !== undefined) {
                GetOneItem(idMongoNewFolder)
                    .then(data => {
                        setIsFolderOwner(data.ownerId == id);
                    })
                    .catch()
            }
        }, [idMongoNewFolder])

        useEffect(() => {
            let items: IMenuItemAction[] = [
                {
                    key: 'upload',
                    text: t("Upload.file"),
                    onClick: () => { upload() },
                    src: documentIcon
                },
                {
                    key: 'Uploadfolder',
                    text: t("Upload.folder"),
                    onClick: () => { uploadFolder() },
                    src: pasteIcon
                },
                {
                    key: 'newFolder',
                    text: t("Upload.newFolder"),
                    onClick: () => { nefolder() },
                    src: pasteIcon
                },
            ];

            setMenuItems(items);
        }, [isAdmin, isFolderOwner]);

        const closeModal = () => {
            setIsModalOpen(false)
        };

        useEffect(() => {
            if (openDeleteBatchModal == false) {
                refresh();
                setSelectedCheckbox([]);
            }
        }, [openDeleteBatchModal]);

        return (
            <>
                <Box className={stylesList.header}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <Box sx={{
                            background: "#E8EFF3",
                            height: '36px',
                            width: '36px',
                            borderRadius: '2px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}>
                            <FolderIcon sx={{
                                color: '#22638D',
                            }} />
                        </Box>

                        <Typography sx={{ font: "normal normal 600 20px/27px Segoe UI", color: "#2D2D2D" }}>{t("WorkspaceList.Documents")}</Typography>
                    </Box>
                    <KeydriveMenuAction
                        titleButton={t("WorkspaceList.New")}
                        startIcon={<Add sx={{ color: "#fff" }} />}
                        menuItems={menuItems}
                        idButton="workspace-item-list-file-header-button-menu-new"
                        idMenu="workspace-item-list-file-header-menu-new"
                        sxButton={KeydriveMenuActionStyle.menuButtonNew}
                        sxMenu={KeydriveMenuActionStyle.menu}
                        sxMenuItems={KeydriveMenuActionStyle.menuItem} />
                </Box>

                <Box>
                    <Typography sx={{
                        margin: "11px 0 0",
                        font: "normal normal normal 14px/21px Segoe UI"
                    }}>
                        {t("WorkspaceList.HeaderText")}
                    </Typography>
                </Box>

                <Divider sx={{ margin: "20px 0px" }} />

                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
                    <KeydriveMenuAction
                        disabledButton={!isActionBatch && selectedCheckboxes.length == 0}
                        titleButton={t("WorkspaceList.DocumentActions")}
                        startIcon={<Add sx={{ color: "#22638D ", fontSize: 30 }} />}
                        endIcon={<ArrowDropDownIcon />}
                        menuItems={menuItemsBach}
                        idButton="workspace-item-list-file-header-button-menu-actions-batch"
                        idMenu="workspace-item-list-file-header-menu-actions-batch"
                        sxButton={KeydriveMenuActionStyle.menuButtonAction}
                        sxMenu={KeydriveMenuActionStyle.menu}
                        sxMenuItems={KeydriveMenuActionStyle.menuItem} />
                           
                    <Box sx={{ display: 'flex', gap: '10px' }}>

                        <IconButton
                            style={{
                                width: '38px',
                                height: '38px',
                                border: '1px solid #22638D',
                                borderRadius: '4px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                            onClick={refreshClick}
                        >
                            <Tooltip title={t("Atualizar.message")}>
                                <RefreshIcon sx={{ color: '#22638D' }} />
                            </Tooltip>
                        </IconButton>

                        <ChooseColumns />
                    </Box>
                </Box>
                <MoveInBatch
                    hideModal={closeModal}
                    isModalOpen={isModalOpen}
                    listItem={selectedCheckboxes}
                    batchRefresh={batchRefresh}
                    idWorkspace={idWorkspace}
                    isMovingOneItem={false}
                />
                <DeleteInBatchModal 
                    batchDeleteResult={batchDeleteResult}
                    setOpenDeleteBatchModal={setOpenDeleteBatchModal}
                    openDeleteBatchModal={openDeleteBatchModal}
                />
                <KeyDriveDialog 
                    dialogTitleCenter
                        keyDriveDialogButtons={{
                        leftButtonMethod: () => {setDeleteBatchConfirmModal(false) },
                        rightButtonMethod: () => {
                            batchDeleteExecute();
                            setDeleteBatchConfirmModal(false);
                        },
                        rightButtonText: t("AdminConsole.Continue"),
                        leftButtonText: t("AdminConsole.Cancel")
                    }}
                    keyDriveDialogContent={{
                        dialogIcon: <Avatar sx={{ backgroundColor: "#E9EFF4", width: "60px", height: "60px" }}><Delete sx={{ color: "#22638D", width: "24px", height: "24px" }}/></Avatar>,
                        dialogTitle: t("DeleteInBatchDialog.ConfirmDialogTitle"),
                        dialogContent: <Container sx={{ textAlign: "center", margin: "0 !important", padding: "0 !important"}}>
                            <div style={{ width: "540px", textAlign: "center", font: "normal normal normal 16px/24px Segoe UI", color: "#969696" }}>{t("DeleteInBatchDialog.ConfirmDialogContent")}</div>
                            <SelectedList listItem={selectedCheckboxes} withCounterInFooter />
                            <div style={{marginTop: "20px"}}>
                                <KeydriveAlert title={t("DeleteInBatchDialog.AlertTitle")} subtitle={t("DeleteInBatchDialog.AlertSubtitle")} variant="info"/>
                            </div>
                    </Container>,
                        handleTogglDialog: () => { setDeleteBatchConfirmModal(false) },
                        openDialog: deleteBatchConfirmModal
                    }}
                />
        </>
        );
    });



export default WorkSpaceItemListFileHeader;
